import type { CardDesignTokens, CardTokenSections } from '@openng/optimus-ui-themes/types/card';

export const root: CardTokenSections.Root = {
	shadow: 'none',
};

export default {
	root,
} satisfies CardDesignTokens;
